// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3OPP_","label":"CategoryService_label__3dASc","location":"CategoryService_location__qSspT"};